export default (props) => ({
    font: `400 ${props.theme.type.type_2} ${props.theme.font.default}`,
    hoverTextDecoration: 'underline',

    ...(props.theme?.atoms?.link)
  });
